import OPhoneDialWindow from './index.vue';

OPhoneDialWindow.install = app => {
  app.component(OPhoneDialWindow.name, OPhoneDialWindow);
};

export default OPhoneDialWindow;
